import React from 'react';
import { Box, Typography, TextField, MenuItem, Chip, Table, TableHead, TableRow, TableCell, TableBody, Skeleton } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { dataAPI } from '../../services/api';
import SectionTitle from '../crt/SectionTitle';
import Panel from '../crt/Panel';

const DataBrowser: React.FC = () => {
  const [schema, setSchema] = React.useState('youtube');
  const [table, setTable] = React.useState('');
  const { data: tablesList, isLoading: loadingTables } = useQuery({
    queryKey: ['data-tables', schema],
    queryFn: async () => (await dataAPI.listTables(schema, false)),
    staleTime: 60000,
  });
  const { data: columns, isLoading: loadingCols } = useQuery({
    queryKey: ['data-columns', schema, table],
    queryFn: async () => (await (await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/v1/data/columns/${schema}/${table}`)).json()),
    enabled: !!schema && !!table,
    staleTime: 60000,
  });
  const { data: sample, isLoading: loadingSample } = useQuery({
    queryKey: ['data-sample', schema, table],
    queryFn: () => dataAPI.sampleTable(schema, table, 25, 0),
    enabled: !!schema && !!table,
    staleTime: 60000,
  });

  return (
    <Box>
      <SectionTitle>DATA BROWSER</SectionTitle>
      <Panel label="QUERY" sx={{ mb: 2, p: 2 }}>
        <Box display="flex" gap={2}>
          <TextField size="small" select label="Schema" value={schema} onChange={(e) => { setSchema(e.target.value); setTable(''); }}>
            {['youtube','personal_youtube','reporting_personal_youtube','dashboard'].map(s => (
              <MenuItem key={s} value={s}>{s}</MenuItem>
            ))}
          </TextField>
          <TextField size="small" select label="Table" value={table} onChange={(e) => setTable(e.target.value)} sx={{ minWidth: 240 }}>
            {(tablesList?.tables || []).map((t: any) => (
              <MenuItem key={t.table} value={t.table}>{t.table} ({t.row_estimate})</MenuItem>
            ))}
          </TextField>
        </Box>
      </Panel>
      {table && (
        <Panel label={`${schema.toUpperCase()}.${table.toUpperCase()}`} sx={{ p: 2 }}>
          <Typography variant="subtitle2" gutterBottom>Columns</Typography>
          {loadingCols ? (
            <Skeleton variant="rectangular" height={60} />
          ) : (
            <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
              {(columns?.columns || []).map((c: any) => (
                <Chip key={c.name} label={`${c.name}: ${c.type}`} />
              ))}
            </Box>
          )}
          <Typography variant="subtitle2" gutterBottom>Sample Rows</Typography>
          {loadingSample ? (
            <Skeleton variant="rectangular" height={200} />
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  {(columns?.columns || []).map((c: any) => (
                    <TableCell key={c.name}>{c.name}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {(sample?.rows || []).map((row: any, idx: number) => (
                  <TableRow key={idx}>
                    {(columns?.columns || []).map((c: any) => (
                      <TableCell key={c.name} sx={{ maxWidth: 240, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {String(row[c.name] ?? '')}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Panel>
      )}
    </Box>
  );
};

export default DataBrowser;

